/**
 * Lightweight CSV exporter — no third-party dependency.
 *
 * Usage:
 *   downloadCsv("gow-payroll.csv",
 *     ["Employee", "Hours", "Subtotal"],
 *     [["John", 12.5, 250.00], ["Mary", 30, 600]]);
 */

function escapeCell(value) {
  if (value === null || value === undefined) return "";
  const s = String(value);
  // RFC 4180: quote fields containing comma, quote, newline, or CR
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function toCsv(headers, rows) {
  const lines = [headers.map(escapeCell).join(",")];
  for (const row of rows) {
    lines.push(row.map(escapeCell).join(","));
  }
  // Prepend UTF-8 BOM so Excel opens accented characters correctly
  return "\uFEFF" + lines.join("\r\n") + "\r\n";
}

export function downloadCsv(filename, headers, rows) {
  const csv = toCsv(headers, rows);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Free memory after the click registered
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * "2026-05-04" from a Date object — used for filenames so they sort
 * naturally in the user's downloads folder.
 */
export function isoDate(d) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}
